import { createFileRoute } from "@tanstack/react-router";
import { TagsScreen } from "../components/tags/TagsScreen";

export const Route = createFileRoute("/_auth/clients/tags")({
  staticData: {
    titleKey: "tags.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 3,
  },
  component: TagsScreen,
});
